import { render, staticRenderFns } from "./top-user.vue?vue&type=template&id=29f6eeb6&scoped=true&"
import script from "./top-user.vue?vue&type=script&lang=js&"
export * from "./top-user.vue?vue&type=script&lang=js&"
import style0 from "./top-user.vue?vue&type=style&index=0&id=29f6eeb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f6eeb6",
  null
  
)

export default component.exports